export const CHAT_ACTIONS = [
    { name: 'New user set up', text: 'Invite a new employee into the system.', enum: 'onboarding' },
    { name: 'User offboarding', text: 'Remove access and deactivate an employee account.', enum: 'offboarding' },
    { name: 'Change User Role', text: 'Update a user\'s role.', enum: 'change_role' },
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]

export const CHAT_ACTIONS_ADMIN = [
    { name: 'New user set up', text: 'Invite a new employee into the system.', enum: 'onboarding' },
    { name: 'User offboarding', text: 'Remove access and deactivate an employee account.', enum: 'offboarding' },
    { name: 'Change User Role', text: 'Update a user\'s role.', enum: 'change_role' },
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]